import React from "react";
import "./Footer.css";
import object from "./footer.json";
const FooterComponent = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {object.map((column) => (
          <div className="footer-column" key={column.col_number}>
            {column.col_values.map((item, index) => (
              <p className="footer-item" key={index}>
                {item}
              </p>
            ))}
          </div>
        ))}
      </div>
    </footer>
  );
};

export default FooterComponent;
